import { format, add } from 'date-fns';
import { FORMAT_QT_DATE } from 'utils/helpers/datetime';

function next7Days(firstDay) {
  const result = [];
  for (let i = 0; i < 7; i++) {
    const d = add(firstDay, { days: i });
    result.push(d);
  }
  return result;
}

export function get7DaysStraight(firstDay) {
  const dateArray = next7Days(firstDay);
  const result = {};
  dateArray.forEach((item) => {
    const key = format(item, FORMAT_QT_DATE);
    result[key] = {
      value: item,
      dayOfWeek: format(item, 'EEE'),
      dayOfMonth: format(item, 'dd/MM'),
    };
  });
  return result;
}

export function transferToSeatMap(rawJson) {
  const dateArray = Object.keys(rawJson);
  const result = {};
  dateArray.forEach((item) => {
    result[item] = rawJson[item].available_units || 0;
  });
  return result;
}
